import React, { useEffect, useState } from "react";

export default function SplashScreen({ onFinish }) {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFade(true);
      setTimeout(onFinish, 400);
    }, 1800);
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#FAF9F6] transition-opacity duration-500 ${
        fade ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <span className="grid h-20 w-20 place-items-center overflow-hidden rounded-full bg-[#050706] shadow-[0_8px_32px_rgba(28,69,50,0.2)]">
        <img src="/theuniversaltree-logo.jpeg" alt="" className="h-full w-full object-cover rounded-full" />
      </span>

      <h1 className="font-display text-xl font-semibold text-[#1A1D1A] mt-4">Universal Tree</h1>

      <div className="mt-6 h-1 w-32 rounded-full bg-[#E2E0D9] overflow-hidden">
        <div className="h-full w-full rounded-full bg-[#1C4532] animate-splash-bar" />
      </div>
    </div>
  );
}
